import Vue from "vue";
import { Drawer } from 'element-ui'
const body = document.body;
function BaseDrawer({ component, props={}, options={}, cbs={}, on={} ,slots ={}}) {
  let instance = new Vue({
    components: {
      Drawer
    },
    data: {
      visible: true,
    },
    render(h) {
      return h("Drawer", {
        props: {
          ...options,
          visible: this.visible
        },
        on: {
          'close': this.onClose,
          ...on
        },
        scopedSlots: {
          default: ()=> h(component, {
            props: {
              ...props,
              cbs
            },
            ref: 'componentVm',
            on: {
              close: this.onClose
            }
          }),
            ...Object.keys(slots).reduce((pre, item)=> {
                pre[item] = slots[item].bind(null, h)
                return pre
            }, {})
        }
      })
    },
    methods: {
      handleVisible() {
        setTimeout(() => {
            if (!instance) {
              return;
            }
            this.$destroy()
            const el = this.$el;
            el && body.removeChild(el);
            instance = null;
      }, 360)
      },
      onClose() {
        this.visible = false;
        window.removeEventListener('popstate', popStateHandle); // 移除popstate事件监听器
        this.handleVisible()
      },
      // 外部方便调用
      close() {
        this.onClose()
      }
    }
  });

  const vm = instance.$mount();
  this.vm = vm;
  this.cVm = vm.$refs.componentVm;
  body.appendChild(vm.$el);
  const popStateHandle = () => {
    vm.close();
  }
  window.addEventListener('popstate', popStateHandle);
};
export default BaseDrawer;
